"use client";

import { useMemo } from "react";

import { preserveSoftLineBreaks, splitParagraphs } from "@/common/cms";
import BorderedIcon from "@/components/BorderedIcon";
import WhatWeDoServiceHeader from "@/components/pages/what-we-do/WhatWeDoHeader";
import SplitText from "mono/components/SplitText";
import { TransitionLink } from "mono/components/TransitionLink";

export default function PageHeader({ data }) {
  const paragraphs = useMemo(() => {
    const html = preserveSoftLineBreaks(data.paragraph);
    return splitParagraphs(html);
  }, [data.paragraph]);

  let strongSeen = 0;

  return (
    <WhatWeDoServiceHeader
      service={data.title}
      serviceBottom={data.titleBottom}
      showSectionTitle={!!data.sectionTitle}
      sectionTitle={data.sectionTitle}
    >
      {paragraphs.length > 0 && (
        <div className="page-header__paragraph">
          {paragraphs.map((innerHtml, i) => {
            const hasStrong = /<strong\b/i.test(innerHtml);
            if (hasStrong) strongSeen += 1;
            const isSectionBreak = hasStrong && strongSeen > 1;

            return (
              <SplitText
                key={i}
                tag="p"
                className={
                  isSectionBreak ? "page-header__paragraph__section-break" : ""
                }
                animateOnScroll
                dangerouslySetInnerHTML={{ __html: innerHtml }}
              >
                {innerHtml}
              </SplitText>
            );
          })}
        </div>
      )}
      {data.ctaLink && data.ctaText && (
        <div style={{ marginTop: "20px" }}>
          <TransitionLink href={data.ctaLink}>
            <BorderedIcon text={data.ctaText} />
          </TransitionLink>
        </div>
      )}
    </WhatWeDoServiceHeader>
  );
}
